import { Component, Inject, Output, EventEmitter, OnInit, ChangeDetectorRef, Input } from '@angular/core';
import { Subject } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { IOrganisation } from '@services/organisation-data.service';
import { GlobalFunctions, imagePath, imgTypes } from '@global/GlobalFunctions';
import { FilesService } from '@services/files.service';
import { ConfirmDialogComponent } from 'src/app/dialogs/confirm-dialog/confirm-dialog.component';

@Component({
	selector: 'app-edit-organisation',
	templateUrl: './edit-organisation.component.html',
	styleUrls: ['./edit-organisation.component.scss']
})
export class EditOrganisationComponent implements OnInit {

	/** Path to Organisation Images */
	public imagePathOrganisations(accountGUID: string): string {
		return imagePath(accountGUID, imgTypes.organisations).toLowerCase()
	}

	/** Update the Image */
	@Output() imageUpdated = new EventEmitter<any>();

	/** Enable the New Picture Button */
	public enablePicture: boolean = true;
	/** Enable the Camera Button */
	public enableCamera: boolean = true;
	/** Enable the Delete Button */
	public enableDelete: boolean = false;

	/** Form Group */
	dialogForm: FormGroup;

	/** new Image Selected */
	public newImage: boolean;

	/** File */
	public file: any
	/** Filename */
	public fileName: string
	/** Loading */
	public loading: boolean
	/** shortLink */
	public shortLink: any
	/** The organisation */
	public organisation: IOrganisation
	/** Creating new organisation */
	public creating: boolean = false;
	/** selected Account */
	imageSrc: string | null = null; // This will hold the image URL for binding
	/** Observable Subject Finalise */
	private finalise = new Subject<void>();

	/**
	 * Default Constructor
	 * @param fb fb
	 * @param dialogRef Referense to the Dialog box
	 * @param filesService filesService
	 * @param cdr Change Detector Ref
	 * @param dialogData object interface
	 * @param globalFunctions 
	 */
	constructor(
		private fb: FormBuilder,
		public dialogRef: MatDialogRef<EditOrganisationComponent>,
		private filesService: FilesService,
		private cdr: ChangeDetectorRef,
		@Inject(MAT_DIALOG_DATA) public dialogData: any,
		public globalFunctions: GlobalFunctions
	) { }

	/**
	 * Page On Initialise Event Handler
	 */
	ngOnInit(): void {

		this.organisation = <IOrganisation>this.dialogData['organisation'];

		if (!this.organisation.Id) {
			this.creating = true;
		}

		this.dialogForm = this.fb.group({
			Id: [this.organisation.Id || 0],
			Uid: [this.organisation.Uid || ''],
			Name: [this.organisation.Name || '', Validators.required],
			Description: [this.organisation.Description || ''],
			ImageURL: [this.organisation.ImageURL || ''],
			tempImageURL: [this.organisation.ImageURL || ''],
			FunctionalLocation: [this.organisation.FunctionalLocation || ''],
			RemindersEnabled: [this.organisation.RemindersEnabled || false],
			ReminderInterval: [this.organisation.ReminderInterval || 0],
		});

		this.imageSrc = imagePath(this.organisation.AccountGUID, imgTypes.organisations) + this.organisation.Id + '?' + this.organisation.Modified
	}

	/**
 * Page On Destroy Event Handler
 */
	ngOnDestroy(): void {
		try {
			// Unsubscribe from all subscriptions
			this.finalise.next();
			this.finalise.complete();
		}
		catch { }
	}

	/**
	 * Cancel button for dialog
	 */
	onCancelClick(): void {
		if (this.dialogForm.dirty) {
			this.globalFunctions.UserConfirm$('Lose any unsaved changes?').subscribe(OKResult => {
				if (OKResult) { this.dialogRef.close(); }
				// do nothing if result is false
			});	
		} else {
			this.dialogRef.close();
		}
	}

	/**
	 * Save the form data and image if needed
	 */
	async onSaveClick(): Promise<void> {

		if (!this.creating) {
			//this.dialogData = { ...this.dialogData, ...this.dialogForm.value };
			this.dialogData['organisation'] = this.dialogForm.value
			this.dialogData['container'] = "prismpdm"
			this.dialogData['file'] = this.file
			this.dialogData['filename'] = this.organisation.Id.toString()
			this.dialogData['folderLocation'] = "organisations"
		}
		else {
			this.dialogData['organisation'] = this.dialogForm.value
			this.dialogData['container'] = "prismpdm"
			this.dialogData['folderLocation'] = "organisations"
		}

		if (this.newImage && this.file) {
			try {
				const accountGUID = this.organisation.AccountGUID?.toString() || ""
				const fileName = this.organisation.Id.toString()
				const location = "organisations";
				await this.filesService.saveImage(accountGUID, fileName, this.file, location); // wait for upload to complete
				this.newImage = false;
				this.file = undefined;
			} // Optional: handle upload failure (maybe prevent closing the dialog)
			catch (error) { return; }
		}

		// Now the upload is done, close the dialog with the form value
		this.dialogRef.close(this.dialogData);
	}

	/**
	 * Delete Image
	 */
	deleteImg(): void {
		// Extract and store the file name
		this.fileName = "transparent.png";
		this.imageSrc = "";
		this.file = new File([""], "transparent.png", { type: "image/png" });
		this.dialogForm.markAsDirty();
		this.newImage = true;
	}

	/**
	 * New File deteced
	 * @param file File from child component
	 */
	onNewImage(file: File | null): void {

		/** Check for a valid file */
		if (file) {
			this.file = file;
			this.newImage = true

		}
		else {
			this.file = undefined;
			this.newImage = false;
		}
		this.dialogForm.markAsDirty();
	}
}
